<template>
  <carousel class="mt-10" :perPage="1">
    <slide v-for="(image, index) in images" :key="index">
      <img
        :src="require('@/assets/projects/' + image)"
        :class="'' + img_size"
      />
    </slide>
  </carousel>
</template>
<script>
import { Carousel, Slide } from "vue-carousel";

export default {
  props: {
    images: {
      type: Array,
    },
    img_size: {
      type: String,
    },
  },
  components: {
    Carousel,
    Slide,
  },
};
</script>
<style scoped>
.sm {
  max-width: 20% !important;
  margin: 0 auto;
}
.lg {
  max-width: 70% !important;
  margin: 0 auto;
}
</style>